namespace GeniuzPOS.InitialData {
    export class PsShopTypeColumns {
        static columnsKey = 'InitialData.PsShopType';
    }
}
